import { gql } from "@apollo/client";

export const EMAIL_LOGS = gql`
  query EmailLogs(
    $where: EmailLogWhereInput
    $recipient: String
    $take: Int
    $skip: Int
    $orderBy: [JSONObject]
  ) {
    emailLogs(
      where: $where
      recipient: $recipient
      take: $take
      skip: $skip
      orderBy: $orderBy
    ) {
      data {
        id
        createdDate
        provider
        isExternal
        from
        to
        cc
        subject
        user {
          id
          firstname
          lastname
        }
      }
      count
    }
  }
`;

export const EMAIL_LOG = gql`
  query EmailLog($where: EmailLogWhereInput) {
    emailLog(where: $where) {
      id
      createdDate
      provider
      isExternal
      from
      to
      cc
      subject
      html
      text
      attachments {
        name
        key
        url
        contentType
        size
      }
      user {
        id
        firstname
        lastname
      }
    }
  }
`;

export const EMAIL_LOG_ATTACHMENT_URL = gql`
  query EmailLogAttachmentUrl($where: EmailLogWhereInput!, $key: String!) {
    emailLogAttachmentUrl(where: $where, key: $key)
  }
`;

const emailLog = { EMAIL_LOGS, EMAIL_LOG, EMAIL_LOG_ATTACHMENT_URL };

export default emailLog;
